import styled from 'styled-components';

import { WPContent as WPContentStyles } from '@/styles/wp';

// STYLES
export const WPContent = styled(WPContentStyles)`
  padding: 0;

  .vce {
    margin-bottom: 0;
  }
`;

export default WPContent;
